<template>
  <div>
    <div class="row">
      <div class="col-12">
        <label class="font-w400">{{
          translate[lang]["solarpanelreturn"]
        }}</label>
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="1"
              class="custom-control-input"
              id="solar1"
              name="products[electricity][solar][status]"
              v-model="cSolarStatus"
            />
            <label class="custom-control-label" for="solar1">{{
              translate[lang]["yes"]
            }}</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="2"
              class="custom-control-input"
              id="solar2"
              name="products[electricity][solar][status]"
              v-model="cSolarStatus"
            />
            <label class="custom-control-label" for="solar2">{{
              translate[lang]["no"]
            }}</label>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-show="cSolarStatus === '1'">
        <label class="font-w400">{{ translate[lang]["kwhknown"] }}</label>
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="1"
              class="custom-control-input"
              id="kwhKnown1"
              name="products[electricity][solar][kwhKnown]"
              v-model="cKwhKnownStatus"
            />
            <label class="custom-control-label" for="kwhKnown1">{{
              translate[lang]["yes"]
            }}</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="2"
              class="custom-control-input"
              id="kwhKnown2"
              name="products[electricity][solar][kwhKnown]"
              v-model="cKwhKnownStatus"
            />
            <label class="custom-control-label" for="kwhKnown2">{{
              translate[lang]["no"]
            }}</label>
          </div>
        </div>
      </div>
      <div
        class="col-md-6"
        v-show="cKwhKnownStatus === '2' && cSolarStatus === '1'"
      >
        <div class="form-group">
          <label for="example-select" class="font-w400">{{
            translate[lang]["choosesolarpanel"]
          }}</label>
          <select
            class="form-control"
            id="example-select"
            name="products[electricity][solar][number_of_panels]"
            v-model="cSolarPanelsNumber"
          >
            <option value="0" selected disabled>
              {{ translate[lang]["pleaseselect"] }}
            </option>
            <option v-for="(item, key) in solars" :key="key" :value="item.id">
              {{ item.label }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="col-md-12"
        v-show="
          cKwhKnownStatus === '1' && cSolarStatus === '1' && smartMeter == 0
        "
      >
        <div class="form-group form-row">
          <div class="col-6" v-show="parseInt(meter) === 1">
            <label for="kwhKnown4">{{ translate[lang]["deliverykwh"] }}</label>
            <input
              type="number"
              id="kwhKnown4"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_single]"
              onkeydown="javascript: return event.keyCode === 8 ||
              event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              v-model="cSolarSingle"
            />
          </div>
        </div>
      </div>
      <div
        class="col-md-12"
        v-show="
          cKwhKnownStatus === '1' && cSolarStatus === '1' && smartMeter == 1
        "
      >
        <div class="form-group form-row">
          <!--
          <div class="col-6" v-show="parseInt(meter) === 1">
            <label for="kwhKnown4">{{ translate[lang]["deliverykwh"] }}</label>
            <input
              type="number"
              id="kwhKnown4"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_single]"
              onkeydown="javascript: return event.keyCode === 8 ||
              event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              v-model="cSolarSingle"
            />
          </div>
          -->
          <!--
          <div class="col-6" v-show="parseInt(meter) === 1">
            <label for="kwhKnown">{{
              translate[lang]["deliverykwhlow"]
            }}</label>
            <input
              type="number"
              id="kwhKnown"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_single_low_kwh]"
              onkeydown="javascript: return event.keyCode === 8 ||
              event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              v-model="cSolarSingleLow"
            />
          </div>
          <div class="col-6" v-show="parseInt(meter) === 1">
            <label for="kwhKnown3">{{
              translate[lang]["deliverykwhnormal"]
            }}</label>
            <input
              type="number"
              id="kwhKnown3"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_single_normal_kwh]"
              onkeydown="javascript: return event.keyCode === 8 ||
              event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              v-model="cSolarSingleHigh"
            />
          </div>
          -->
          <div class="col-6">
            <label for="kwhKnownn">{{
              translate[lang]["deliverykwhnormal"]
            }}</label>
            <input
              type="number"
              id="kwhKnownn"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_normal_kwh]"
              v-model="cSolarHigh"
            />
          </div>
          <div class="col-6">
            <label for="kwhKnownl">{{
              translate[lang]["deliverykwhlow"]
            }}</label>
            <input
              type="number"
              id="kwhKnownl"
              class="form-control"
              placeholder="kWh"
              name="products[electricity][solar][return_delivery_low_kwh]"
              v-model="cSolarLow"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="form-group">
          <label class="d-block" id="supplierAdress"
            >{{
              translate[lang]["supplierAdress"]
            }}</label
          >
          <div class="form-check form-check-inline">
            <input
                class="form-check-input"
                type="radio"
                value="0"
                id="moving_id"
                checked
                name="widgets[personaldata][supplierAdress]"
            />
            <label class="form-check-label" for="moving_id" id="moving2"
            >{{
                translate[lang]["moving2"]
              }}</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              value="1"
              id="switching_id"
              name="widgets[personaldata][supplierAdress]"
            />
            <label class="form-check-label" for="switching_id" id="switching1"
              >{{
                translate[lang]["switching1"]
              }}</label
            >
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
//import $ from "jquery";
export default {
  name: "Solar",
  data() {
    return {};
  },
  async created() {
    await this.getSolarList();
  },
  computed: {
    ...mapState({
      solars: (state) => state.forms.solars,
      solarStatus: (state) => state.forms.solar.status,
      kwhKnownStatus: (state) => state.forms.solar.kwhKnown,
      solarPanelsNumber: (state) => state.forms.solar.number_of_panels,
      solarSingle: (state) => state.forms.solar.single,
      solarLow: (state) => state.forms.solar.low,
      solarHigh: (state) => state.forms.solar.high,
      smartMeter: (state) => state.forms.smartMeter,
    }),
    cSolarStatus: {
      get() {
        return this.solarStatus;
      },
      set(val) {
        this.setSolarStatus(val);
        if (val === "2") {
          this.setKwhKnownStatus("2");
        }
      },
    },
    cKwhKnownStatus: {
      get() {
        return this.kwhKnownStatus;
      },
      set(val) {
        this.setKwhKnownStatus(val);
      },
    },
    cSolarPanelsNumber: {
      get() {
        return this.solarPanelsNumber;
      },
      set(val) {
        this.setNumberOfSolarPanels(val);
        this.setSolar()
      },
    },
    cSolarSingle: {
      get() {
        return this.solarSingle;
      },
      set(val) {
        if (val == "") {
          this.setSolarSingle(0);
        } else {
          this.setSolarSingle(val);
        }
      },
    },
    cSolarSingleLow: {
      get() {
        return this.solarLow;
      },
      set(val) {
        if (val == "") {
          this.setSolarLow(0);
          this.setSolarSingle(parseInt(this.solarHigh));
        } else {
          this.setSolarLow(val);
          this.setSolarSingle(parseInt(val) + parseInt(this.solarHigh));
        }
      },
    },
    cSolarSingleHigh: {
      get() {
        return this.solarHigh;
      },
      set(val) {
        if (val == "") {
          this.setSolarHigh(0);
          this.setSolarSingle(parseInt(this.solarLow));
        } else {
          this.setSolarHigh(val);
          this.setSolarSingle(parseInt(val) + parseInt(this.solarLow));
        }
      },
    },
    cSolarLow: {
      get() {
        return this.solarLow;
      },
      set(val) {
        if (val == "") {
          this.setSolarLow(0);
          this.setSolarSingle(parseInt(this.solarHigh) + "");
        } else {
          this.setSolarLow(val);
          this.setSolarSingle(parseInt(val) + parseInt(this.solarHigh) + "");
        }
      },
    },
    cSolarHigh: {
      get() {
        return this.solarHigh;
      },
      set(val) {
        if (val == "") {
          this.setSolarHigh(0);
          this.setSolarSingle(parseInt(this.solarLow) + "");
        } else {
          this.setSolarHigh(val);
          this.setSolarSingle(parseInt(val) + parseInt(this.solarLow) + "");
        }
      },
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      getSolarList: "forms/getSolarList",
    }),
    ...mapMutations({
      setSolarStatus: "forms/SET_SOLAR_STATUS",
      setKwhKnownStatus: "forms/SET_KWHKNOWN_STATUS",
      setNumberOfSolarPanels: "forms/SET_SOLAR_PANELS",
      setSolarSingle: "forms/SET_SOLAR_SINGLE",
      setSolarLow: "forms/SET_SOLAR_LOW",
      setSolarHigh: "forms/SET_SOLAR_HIGH",
    }),
    setSolar() {
      this.$store.state.forms.solar.single = null;
      this.$store.state.forms.solar.low = null;
      this.$store.state.forms.solar.high = null;

      if (this.cSolarStatus === "1") {
        (this.$store.state.forms.solar.single = this.solars.filter(
          (x) => x.id === parseInt(this.cSolarPanelsNumber)
        )[0].single),
          (this.$store.state.forms.solar.low = this.solars.filter(
            (x) => x.id === parseInt(this.cSolarPanelsNumber)
          )[0].low),
          (this.$store.state.forms.solar.high = this.solars.filter(
            (x) => x.id === parseInt(this.cSolarPanelsNumber)
          )[0].high);
      }
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
